import Api from '../../utils/api'
import { ProductStockData } from './types'
import MockData from '../../components/organisms/ConfigureAndBuy/api-mock-stock-data.mock'

const getProductsStockData = async ({
  cbxUrl,
  market,
  channel,
  articleList = [],
  isMock = false
}: {
  cbxUrl: string
  market: string
  channel: string
  articleList: string[]
  isMock?: boolean
}): Promise<ProductStockData[] | null> => {
  if (isMock) {
    return MockData
  }
  const headers = {
    'Content-Type': 'application/json'
  }

  const options = {
    method: 'POST',
    headers,
    body: JSON.stringify({ articleList })
  }

  const queryParams = new URLSearchParams({
    ...(market && { market }),
    ...(channel && { channel })
  })

  const res = await Api.fetch(
    `${cbxUrl}/stocks/visibility/v1.0/stock-quantities?${queryParams.toString()}`,
    options
  )

  if (res) {
    const { products } = await res.json()

    return products
  }

  return null
}

export default {
  getProductsStockData
}
